import styled from "styled-components";
import { colorSecondary, hex2rgba } from "../../colors";
import { BreakPoints, ContentWidths } from "../../constants";

export const StyledImageText = styled.section.attrs({
  className: "image-text__container"
})`
  width: 100%;
  display: flex;
  justify-content: center;

  .image-text {
    margin: 15px;
    display: flex;
    flex-direction: column;

    @media (min-width: ${BreakPoints.sm}) {
      width: ${ContentWidths.sm};
    }

    @media (min-width: ${BreakPoints.md}) {
      margin: 0;
      width: ${ContentWidths.md};
      justify-content: space-between;
      align-items: flex-start;
      &--left {
        flex-direction: row-reverse;
      }
      &--right {
        flex-direction: row;
      }
    }

    @media (min-width: ${BreakPoints.lg}) {
      width: ${ContentWidths.lg};
    }

    @media (min-width: ${BreakPoints.xl}) {
      width: ${ContentWidths.xl};
    }

    &__text {

      @media (min-width: ${BreakPoints.md}) {
        width: 240px;
        padding: 0 15px;
      }

      @media (min-width: ${BreakPoints.lg}) {
        width: 320px;
      }

      @media (min-width: ${BreakPoints.xl}) {
        width: 380px;
      }
    }

    &__subtitle {
      font-family: Pitch Sans Bold;
      text-transform: uppercase;
      font-size: 0.8125rem;
      font-weight: bold;
      color: ${hex2rgba(colorSecondary, 0.6)};
      margin: 0 0 16px 0;
      letter-spacing: 0.2em;
    }

    &__title {
      font-family: Kapra Neue Pro;
      text-transform: uppercase;
      font-size: 3rem;
      font-weight: normal;
      color: ${colorSecondary};
      margin: 0 0 24px 0;
      line-height: 1;
    }

    &__sentence {
      font-family: Rubik;
      color: ${hex2rgba(colorSecondary, 0.6)};
      font-size: 1rem;
      margin: 0 0 16px 0;
    }

    &__image {
      width: 100%;
      object-fit: contain;

      @media (min-width: ${BreakPoints.md}) {
        max-width: 450px;
        padding: 0 15px;
        height: auto;
      }

      @media (min-width: ${BreakPoints.lg}) {
        max-width: 610px;
      }

      @media (min-width: ${BreakPoints.xl}) {
        max-width: 730px;
      }
    }
    
  }
  
  
  
`;